import { useState } from "react";
import { Link, NavLink as RouterNavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "@/assets/logo-navbar.webp";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Restrooms", to: "/restrooms" },
  { label: "Events", to: "/events" },
  { label: "Blog", to: "/blog" },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b border-brand-linen bg-[#1c1c1c]/40">
      {/* Skip to content */}
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>

      <nav className="container mx-auto flex items-center justify-between h-16 sm:h-20 px-4 sm:px-6" aria-label="Main navigation">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0" aria-label="WG Luxury Restrooms — Home">
          <img
            src={logo}
            alt="WG Luxury Restrooms"
            width={253}
            height={40}
            // @ts-ignore
            fetchpriority="high"
            decoding="async"
            className="h-6 sm:h-7 md:h-8 lg:h-10 w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-6 lg:gap-8">
          {navLinks.map((link) => (
            <li key={link.to}>
              <RouterNavLink
                to={link.to}
                className={({ isActive }) =>
                  `relative tracking-[0.12em] uppercase font-sans font-medium text-sm transition-colors duration-300 ${
                    isActive ? "text-primary" : "text-primary-foreground hover:text-primary"
                  } after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:bg-primary after:transition-all after:duration-300 after:ease-out ${
                    isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
                  }`
                }
              >
                {link.label}
              </RouterNavLink>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <Link
          to="/contact"
          className="hidden md:inline-flex items-center px-5 lg:px-7 py-2 lg:py-2.5 bg-primary text-primary-foreground text-[11px] tracking-[0.14em] uppercase font-sans font-semibold rounded-pill hover:shadow-brand-gold hover:-translate-y-px active:scale-[0.97] transition-all"
        >
          Contact Us
        </Link>

        {/* Mobile toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-primary-foreground p-2 -mr-2"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {/* Mobile menu */}
      <div
        className={`md:hidden bg-background border-t border-brand-linen overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
        }`}
        aria-hidden={!mobileOpen}
      >
        <div className="px-4 sm:px-6 py-6 sm:py-8 space-y-4 sm:space-y-6">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className="block text-[11px] tracking-[0.12em] uppercase font-sans font-medium text-brand-slate hover:text-primary transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMobileOpen(false)}
            className="inline-flex items-center px-7 py-2.5 bg-primary text-primary-foreground text-[11px] tracking-[0.14em] uppercase font-sans font-semibold rounded-pill"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
